import React, { useState } from 'react';
import { EyeIcon } from '../icons/EyeIcon';
import { ConvertIcon } from '../icons/ConvertIcon';
import ChevronIcon from '../icons/ChevronIcon';
import ConfirmationModal from '../ConfirmationModal';
import {
    TodoHeader as Header,
    Title,
    HeaderActions,
    TodoOptions,
    TodoCount,
    ToggleButton,
    ConvertAllButton,
    CollapseButton
} from '../../styles/TodoList.styles';

const TodoHeader = ({
    title,
    isCollapsed,
    todos,
    hideCompleted,
    setHideCompleted,
    incompleteTodos,
    onConvertAllToCards,
    onCollapse,
    onAddTodo
}) => {
    const [showConfirmation, setShowConfirmation] = useState(false);
    const completedCount = todos.filter(todo => todo.completed).length;

    const handleConvertAll = () => {
        setShowConfirmation(true);
    };

    const [newTodoText, setNewTodoText] = useState('');

    const handleAddTodo = (e) => {
        if (e.key === 'Enter' && newTodoText.trim()) {
            onAddTodo(newTodoText);
            setNewTodoText('');
        }
    };

    const handleAddTodoClick = () => {
        if (newTodoText.trim()) {
            onAddTodo(newTodoText);
            setNewTodoText('');
        }
    };

    return (
        <Header isCollapsed={isCollapsed}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <Title>{title}</Title>
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {onAddTodo && isCollapsed && (
                    <div style={{ position: 'relative', marginRight: '12px' }}>
                        <input
                            type="text"
                            value={newTodoText}
                            onChange={(e) => setNewTodoText(e.target.value)}
                            onKeyPress={handleAddTodo}
                            placeholder="Add a todo..."
                            style={{
                                flexGrow: '1',
                                backgroundColor: 'transparent',
                                color: 'white',
                                border: '1px solid white',
                                padding: '5px 30px 5px 5px', // Adjusted padding
                                fontSize: '14px',
                                borderRadius: '3px',
                                width: '160px',
                                outline: 'none',
                                '::placeholder': {
                                    color: 'white'
                                }
                            }}
                        />
                        <button
                            onClick={handleAddTodoClick}
                            style={{
                                position: 'absolute',
                                right: '5px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                color: '#B6C2CF',
                                fontSize: '16px',
                                padding: '0 5px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                width: '20px',
                                height: '20px',
                                transition: 'background-color 0.2s ease',
                                ':hover': {
                                    backgroundColor: 'rgba(87, 157, 255, 0.1)'
                                }
                            }}
                            title="Add todo"
                        >
                            +
                        </button>
                    </div>
                )}
                {!isCollapsed && (
                    <HeaderActions>
                        <TodoOptions>
                            <TodoCount completed={completedCount === todos.length}>
                                {completedCount}/{todos.length}
                            </TodoCount>
                            <ToggleButton
                                onClick={() => setHideCompleted(!hideCompleted)}
                                title={hideCompleted ? "Show completed items" : "Hide completed items"}
                            >
                                <EyeIcon hidden={hideCompleted} />
                            </ToggleButton>
                            {incompleteTodos.length > 0 && onConvertAllToCards && (
                                <ConvertAllButton
                                    onClick={handleConvertAll}
                                    title="Convert all incomplete items to cards"
                                >
                                    <ConvertIcon />
                                    Convert All to Cards
                                </ConvertAllButton>
                            )}
                        </TodoOptions>
                    </HeaderActions>
                )}
                {onCollapse && (
                    <CollapseButton
                        onClick={() => onCollapse(!isCollapsed)}
                        title={isCollapsed ? 'Expand' : 'Collapse'}
                    >
                        <ChevronIcon direction={isCollapsed ? 'down' : 'up'} />
                    </CollapseButton>
                )}
            </div>

            {showConfirmation && (
                <ConfirmationModal
                    title="Convert All to Cards"
                    confirmText="Convert All"
                    message={`Are you sure you want to convert all ${incompleteTodos.length} incomplete ${incompleteTodos.length === 1 ? 'item' : 'items'
                        } to cards? This action cannot be undone.`}
                    onConfirm={() => {
                        onConvertAllToCards(incompleteTodos);
                        setShowConfirmation(false);
                    }}
                    onCancel={() => setShowConfirmation(false)}
                />
            )}
        </Header>
    );
};

export default TodoHeader;
